import React from 'react';

/**
 * BackgroundBoxes: Interactive grid background with hover animations
 * Based on shadcn.io background boxes pattern
 */
const BackgroundBoxes = () => {
  const rows = new Array(80).fill(1); // Reduced for better performance
  const cols = new Array(60).fill(1); // Reduced for better performance

  // Color palette for hover animations
  const colors = [
    "rgb(125 211 252)", // sky-300
    "rgb(249 168 212)", // pink-300
    "rgb(134 239 172)", // green-300
    "rgb(253 224 71)",  // yellow-300
    "rgb(252 165 165)", // red-300
    "rgb(216 180 254)", // purple-300
    "rgb(147 197 253)", // blue-300
    "rgb(165 180 252)", // indigo-300
    "rgb(196 181 253)", // violet-300
  ];

  const getRandomColor = () => {
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = getRandomColor();
    e.target.style.transition = 'background-color 0s';
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = 'transparent';
    e.target.style.transition = 'background-color 2s';
  };

  return (
    <div
      className="background-boxes-grid"
      style={{
        transform: `translate(-40%,-60%) skewX(-48deg) skewY(14deg) scale(0.675) rotate(0deg) translateZ(0)`,
        position: 'absolute',
        left: '25%',
        top: '-25%',
        display: 'flex',
        width: '100%',
        height: '100%',
        zIndex: 0,
        padding: '1rem'
      }}
    >
      {rows.map((_, i) => (
        <div
          key={`row-${i}`}
          style={{
            width: '64px',
            height: '32px',
            borderLeft: '1px solid rgb(51 65 85)', // slate-700
            position: 'relative'
          }}
        >
          {cols.map((_, j) => (
            <div
              key={`col-${j}`}
              style={{
                width: '64px',
                height: '32px',
                borderRight: '1px solid rgb(51 65 85)', // slate-700
                borderTop: '1px solid rgb(51 65 85)', // slate-700
                position: 'relative',
                cursor: 'pointer'
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {j % 2 === 0 && i % 2 === 0 && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  style={{
                    position: 'absolute',
                    height: '24px',
                    width: '40px',
                    top: '-14px',
                    left: '-22px',
                    color: 'rgb(51 65 85)', // slate-700
                    strokeWidth: '1px',
                    pointerEvents: 'none'
                  }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6v12m6-6H6"
                  />
                </svg>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default BackgroundBoxes;